module.exports = __webpack_public_path__ + "img/arrow-right.30e3a3a0.svg";